import React from 'react';
import { FormComponent } from '../../../components/form/DynamicForm';
import { Form } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import { objectAsParams } from '../../../helpers';
import moment from 'moment';

class ReporteManifiestos extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'contra-recibo/one', saveUrl: 'contra-recibo/save', backUrl: 'jfhdfs' },
      new Form([
        Form.Field('text', 'remision', 'Remisión', '', [], 6),
        Form.Field('text', 'guia', 'Guía Exxprezo', '', [], 6),
        Form.Field('date', 'doc_inicio', 'Fecha documentación (inicio)', null, [], 6),
        Form.Field('date', 'doc_fin', 'Fecha documentación (fin)', false, [], 6),
        Form.Field('date', 'emb_inicio', 'Fecha embarque (inicio)', false, [], 6),
        Form.Field('date', 'emb_fin', 'Fecha embarque (fin)', false, [], 6),
      ], ['Reporte'], 'Reportes'), this.formData
    )

    // this.LoadPreds(this.props.factura.id, false);
  }

  formData = async (form) => {
    let newForm = form;
    // let Res = await Http.get('reportes-cobranza/reporte/form');
    // console.log(Res);
    // if (!Res.error) {
      // newForm = Form.FieldOptions(form, 'id_sucursal', [{ id: 0, sucursal_nombre: 'Cualquiera' }, ...Res.data.sucursales], 'id', 'sucursal_nombre');
      // newForm = Form.FieldOptions(form, 'id_ejecutivo', [{ id: 0, ejecutivo_nombre: 'Cualquiera' }, ...Res.data.ejecutivos], 'id', 'ejecutivo_nombre');
      // newForm = Form.FieldOptions(form, 'id_cliente', [{ id: 0, cliente_rsocial: 'Cualquiera' }, ...Res.data.clientes], 'id', 'cliente_rsocial');
    // }
    return newForm;
  }

  onSubmit = async (button, vals) => {
    // console.log(vals);
    this.setState({ loading: true });
    const doc_inicio = moment(vals.doc_inicio).format('YYYY-MM-DD');
    const doc_fin = moment(vals.doc_fin).format('YYYY-MM-DD');
    const emb_inicio = moment(vals.emb_inicio).format('YYYY-MM-DD');
    const emb_fin = moment(vals.emb_fin).format('YYYY-MM-DD');

    let params = {
      ...vals,
      doc_inicio,
      doc_fin,
      emb_inicio,
      emb_fin,
    }
    try {
      let Res = await Http.get(`cliente-manifiesto/reporte?${objectAsParams(params)}`, true, 'arraybuffer');
      console.log(Res);

      if (Res) {
        const blob = new Blob([Res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Reporte.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      // if (!Res.error) {

      // }
    } catch (error) {
      console.log(error)
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div style={{ backgroundColor: 'white' }}>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(ReporteManifiestos)
